export function AboutPage() {
    return (<div>

        <p>
            I use this website to host and provide information about myself and my projects as well as to further
            develop my webdev skills. For now, this is simply a frontend with no real backend.
        </p>
        <p>
            Yes, the design is intended to look like this. I like it.
        </p>
    </div>)
}